<template>
  <b-container fluid style="background-color:#fff">
    <PortalNavbar></PortalNavbar>

    <!-- <b-alert variant="danger" :show="dismissCountDown"
             dismissible  @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
             <Notice></Notice>
        </b-alert> -->

    <b-row class="mt-5 login-row-wrap">




      <b-col xl="4" lg="4" offset-xl="1">
        <!-- <div class="microsoft containerx">
                        <p class="marquee">Windows 8 and Windows RT are focused on your life—your friends and family, your apps, and your stuff. With new things like the <a href="http://windows.microsoft.com/en-US/windows-8/start-screen">Start screen</a>, <a href="http://windows.microsoft.com/en-US/windows-8/charms">charms</a>, and a <a href="http://windows.microsoft.com/en-US/windows-8/microsoft-account">Microsoft account</a>, you can spend less time searching and more time doing.</p>
                    </div> -->

        <div class="login-wrapper">

          <div class="login-box-inner">


            <h6>Login</h6>
            <hr style="margin-top:0.5rem;margin-bottom:0.5rem;" />
            <b-row>
              <b-col>
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-alert :show="showDismissibleAlert" dismissible @dismissed="showDismissibleAlert = false"
                    :variant="variant">
                    {{ alertText }}
                  </b-alert>
                  <div class="form-group">
                    <small for="exampleInputEmail1">User Name</small>
                    <b-input type="text" :formatter="format" lazy-formatter v-model="form.userName" required
                      class="form-control" size="sm" id="inputUserID" aria-describedby="emailHelp"
                      placeholder="Enter Your UserName"></b-input>
                  </div>

                  <div class="form-group">
                    <small for="exampleInputEmail1">Password</small>
                    <b-input type="password" :formatter="format" lazy-formatter v-model="form.Password"
                      class="form-control" size="sm" id="inputPwd" aria-describedby="emailHelp"
                      placeholder="Enter Password"></b-input>
                  </div>
                  <div>
                    <button class="btn btn-primary btn-sm float-right" type="submit">Login</button>
                    <Spinner size="16" message="Loading..." v-if="isLoading"> </Spinner>
                  </div>
                  <div>
                    <b-btn variant="link" size="sm" class="float-right" @click="showModal">Forgot Password</b-btn>
                  </div>

                </b-form>
                <div style="text-align:center;margin-top:60px;">
                  <b-btn variant="link" size="sm" to="/LoginProfile">New User? Signup Now</b-btn>
                </div>
              </b-col>
            </b-row>
          </div>



          <a href="http://www.msobcfdc.org/" class="link-anchor">
            Click here to go back on <span class="link">https://www.vnvjntdc.org/</span>
          </a>
        </div>
      </b-col>

      <b-col xl="6" lg="8">
        <StatComponent2></StatComponent2>
      </b-col>



    </b-row>

    <b-modal ref="myModalRef" title="Forgot Password?" hide-footer>
      <ForgotPassword @close="hideModal()"></ForgotPassword>
    </b-modal>


  </b-container>
</template>

<script>

import StatComponent2 from "@/components/Portal/StatComponent2";
import apis from "@/apis";
import ForgotPassword from "@/components/ForgotPassword";
import PortalNavbar from "@/components/PortalNavbar";
import Spinner from "vue-simple-spinner";

export default {
  components: { Spinner, PortalNavbar, ForgotPassword, StatComponent2 },
  data() {
    return {
      dismissSecs: 20,
      dismissCountDown: 0,
      form: {
        userName: "",
        Password: ""
      },
      slide: 0,
      sliding: null,
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;

      let promise = apis.login(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            let userary = response.body;
            if (userary.length == 0) {
              this.alertText = "User name or Password is invalid";

              this.variant = "warning";
              this.showDismissibleAlert = true;
            } else {
              this.$store.dispatch("login", {
                token: response.body[0].SessionID,
                user: response.body[0]
              });
              // Set user's district for filtering
              if (response.body[0].DistrictID) {
                this.$store.dispatch("setUserDistrict", response.body[0].DistrictID);
              }
              this.$router.replace("/dashboard");
            }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset(evt) { }
  },
  mounted() {
    this.dismissCountDown = this.dismissSecs
  }
};
</script>

<style scoped>
body {
  background: #e8eff9 !important;
}

ul {
  padding: 0;
  margin: 0;
}

.top-land {
  /*border-bottom : solid 2px #ccc;*/
  padding-top: 10px;
  padding-bottom: 10px;
}

.navbar {
  padding: 0 !important;
  background: #5c6bc0 !important;
}

.navbar-brand {
  font-size: 12pt !important;
  color: #ccc !important;
}

.login-box-inner {
  background: #fbfbfb;
  padding: 25px 20px;
  border: solid thin #ddd;
  border-radius: 4px;
  -webkit-box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
  box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
}

.nav-item:hover .login-box {
  display: block;
}

.containerx {
  width: 100%;
  height: 95%;
  margin-bottom: 1em auto;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }

  100% {
    top: -11em;
  }
}

/* Make it look pretty */
.microsoft .marquee {
  margin: 0;
  padding: 0 1em;
  line-height: 1.5em;
  font: 1em "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

.microsoft:before,
.microsoft::before,
.microsoft:after,
.microsoft::after {
  left: 0;
  z-index: 1;
  content: "";
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 2em;
  background-image: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));
}

.microsoft:after,
.microsoft::after {
  bottom: 0;
  transform: rotate(180deg);
}

.microsoft:before,
.microsoft::before {
  top: 0;
}

.rounded-circle {
  width: 100%;
  max-width: 200px;
  margin-bottom: 10px;
}

.guidelines {
  background: url(../assets/pdfIcon.png) no-repeat left 1px;
  padding-left: 28px;
  display: block;
  /* float: left; width: 100%;*/
  /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font: 0.8rem "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

.newsnevents {
  display: block;
  /* float: left; width: 100%;*/
  /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font-size: 0.8rem;
}


/* UI changes by Akshay 15-08-2019 */

.login-row-wrap {
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px !important;
  margin-bottom: 30px;
}

.link-anchor {
  margin-top: 35px;
  margin-bottom: 35px;
  margin-left: auto;
  margin-right: auto;
  background-color: #9e4141;
  padding: 15px;
  color: #fff;
  display: block;
  border-radius: 6px;
  width: fit-content;
  padding-left: 25px;
  padding-right: 25px;
  text-align: center;
  font-size: 14px;
}

.link-anchor .link {
  text-decoration: underline;
  color: #f5f599;
}

.container-fluid {
  overflow: hidden;
}


.login-wrapper {
  margin: auto;
  max-width: 400px;
  margin-bottom: 20px;
}

@media(max-width: 420px) {
  .login-wrapper {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;

  }
}</style>



// WEBPACK FOOTER //
// src/components/LoginNew.vue